import React, { useEffect } from 'react';
import { Tab } from '@material-ui/core';
import { uniqueId } from 'lodash';
import { StyledTabs } from 'components/SahamTabs/styled-components';

export interface SahamTabsProps {
  children?: React.ReactNode[];
  labels: string[];
  currentTabIndex: number;
  onTabClick?: Function;
}

const SahamTabs: React.FC<SahamTabsProps> = (props): JSX.Element => {
  const { currentTabIndex, children, labels, onTabClick } = props;

  const [currentTab, setCurrentTab] = React.useState<number>(currentTabIndex);
  useEffect(() => {
    if (onTabClick) onTabClick(currentTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabIndex, onTabClick, currentTab]);

  const handleChangeTab = (event: React.ChangeEvent<{}>, newTab: number) => {
    if (onTabClick) onTabClick(currentTab);
    setCurrentTab(newTab);
  };

  return (
    <>
      <StyledTabs
        value={currentTab}
        onChange={handleChangeTab}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        {React.Children.toArray(children).map((_, index) => (
          <Tab
            id={`scrollable-force-tab-${index}`}
            key={uniqueId('sahamtab')}
            label={labels[index]}
          />
        ))}
      </StyledTabs>
      {React.Children.toArray(children)[currentTab]}
    </>
  );
};

export default SahamTabs;
